import { authHeader } from "../_helpers";
import config from "../config";
import { handleResponse } from "../_helpers/response";

const baseUrl = config.apiGateway.baseUrl;

export const imageProvisionService = {
  allocate,
  list,
  remove,
  saveCdwa,
};

function allocate(values) {
  return fetch(`${baseUrl}/image-provision/allocate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  }).then(handleResponse);
}

function list() {
  return fetch(`${baseUrl}/image-provision/list`, {
    method: "GET",
    headers: authHeader(),
  }).then(handleResponse);
}

function remove(values) {
  return fetch(`${baseUrl}/image-provision/remove`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  }).then(handleResponse);
}

function saveCdwa(rows) {
  return fetch(`${baseUrl}/image-provision/cdwa`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ rows }),
  }).then(handleResponse);
}
